<template>
  <el-dialog
    :model-value="modelValue"
    custom-class="el-dialog--custom"
    width="420px"
    top="0"
    :title="$t('save_search_condition')"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :show-close="true"
    @close="$emit('update:modelValue', false)"
  >
    <el-input
      v-model="inputName"
      :placeholder="$t('save_search_condition_name_placeholder')"
      :maxlength="50"
      :disabled="loading"
      @keyup.enter="handleConfirm"
    />
    <p v-if="isDuplicate" class="text-red-500 text-xs mt-1">{{ $t('duplicate_saved_search_condition_name') }}</p>
    <template #footer>
      <div class="flex">
        <div class="flex-1">
          <el-button type="default" class="btn-default-cancel" @click="$emit('update:modelValue', false)">
            {{ $t('barcode_type.cancel') }}
          </el-button>
        </div>
        <div class="flex-1">
          <el-button
            type="primary"
            :disabled="!inputName.trim() || isDuplicate || loading"
            :loading="loading"
            @click="handleConfirm"
          >
            {{ $t('save') }}
          </el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'

@Options({
  name: 'SaveConditionDialog',
  emits: ['update:modelValue', 'confirm'],
})
export default class SaveConditionDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly modelValue!: boolean
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean
  @Prop({ type: Array, default: () => [] }) readonly existingNames!: string[]

  inputName = ''

  get isDuplicate(): boolean {
    const trimmed = this.inputName.trim().toLowerCase()
    return !!trimmed && this.existingNames.some((n) => n.trim().toLowerCase() === trimmed)
  }

  @Watch('modelValue')
  onVisibilityChange(val: boolean) {
    if (!val) this.inputName = ''
  }

  handleConfirm() {
    if (!this.inputName.trim() || this.isDuplicate || this.loading) return
    this.$emit('confirm', this.inputName.trim())
  }
}
</script>
